import { useApp } from "../context/AppContext";

function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#050505] pt-28 md:pt-36 pb-24">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <p className="text-xs tracking-[0.3em] uppercase text-[var(--gold)] mb-4">HRH Riviera Maya Cancun</p>
        <h1 className="font-serif font-light text-4xl md:text-6xl tracking-tight mb-4">{title}</h1>
        <p className="text-white/40 text-sm mb-14">Last updated: {updated}</p>
        <div className="space-y-8 text-white/70 font-light leading-relaxed [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3">
          {children}
        </div>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="June 2026">
      <p><em>This is placeholder content provided for payment-provider review and must be reviewed by legal counsel before public use.</em></p>
      <h2>1. Services</h2>
      <p>HRH Riviera Maya Cancun provides private ground transportation (private van) between Cancun International Airport and hotels, archaeological sites and tourist destinations across Cancun and the Riviera Maya.</p>
      <h2>2. Reservations</h2>
      <p>All reservations are subject to availability and confirmation. Prices are quoted per private van per destination and are shown at the time of booking. Round-trip fares are calculated as two one-way fares.</p>
      <h2>3. Payments</h2>
      <p>Payments are processed securely through Mercado Pago. Your reservation is confirmed once payment is received or your details are verified by our team.</p>
      <h2>4. Cancellations & Refunds</h2>
      <p>Cancellations made at least 24 hours before the scheduled pickup are eligible for a full refund. Later cancellations or no-shows may be non-refundable. Contact us to request changes.</p>
      <h2>5. Meet & Greet</h2>
      <p>For airport arrivals, your driver will be waiting outside the terminal holding a sign with your name. Please provide accurate flight details to ensure timely service.</p>
      <h2>6. Liability</h2>
      <p>HRH Riviera Maya Cancun is not responsible for delays caused by circumstances beyond our control, including weather, traffic or flight schedule changes. Passengers travel subject to applicable local regulations.</p>
      <h2>7. Contact</h2>
      <p>For any questions regarding these terms, contact info@hrhrivieramaya-cancun.com.</p>
    </LegalLayout>
  );
}

export function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p><em>This is placeholder content provided for payment-provider review and must be reviewed by legal counsel before public use.</em></p>
      <h2>1. Information We Collect</h2>
      <p>We collect the personal information you provide when booking a transfer or contacting us, including your name, email, phone number, flight details and destination.</p>
      <h2>2. How We Use It</h2>
      <p>Your information is used solely to process reservations, coordinate your transfer, communicate with you and comply with legal obligations.</p>
      <h2>3. Payments</h2>
      <p>Payment data is handled directly by our payment processor, Mercado Pago. We do not store your full card details on our servers.</p>
      <h2>4. Sharing</h2>
      <p>We do not sell your personal data. Information may be shared with drivers and service partners strictly to fulfill your booking.</p>
      <h2>5. Data Retention & Rights</h2>
      <p>We retain booking records as required for accounting and legal purposes. You may request access, correction or deletion of your data by contacting us.</p>
      <h2>6. Contact</h2>
      <p>For privacy inquiries, contact info@hrhrivieramaya-cancun.com.</p>
    </LegalLayout>
  );
}
